import { HttpClient } from '@angular/common/http';
import { computed, effect, Injectable, Signal, inject } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CurrentUserService } from './current-user.service';
import { MessageHandlerService } from './messageHandler.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly http = inject(HttpClient);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly messageService = inject(MessageHandlerService);

  public readonly isDark$: Signal<boolean> = computed(() => {
    return this.currentUserService.currentUser$()?.darkTheme ?? false;
  });

  constructor() {
    effect(() => {
      const body = document.body;
      if (this.isDark$()) {
        document.body.className = `${body.className} dark`;
      } else {
        document.body.className = body.className.replace('dark', '').trim();
      }
    });
  }

  update() {
    const darkTheme = !this.isDark$();
    return this.http
      .put<any>(
        `${environment.baseUrl}/users/customer/updateTheme/${darkTheme}`,
        undefined
      )
      .pipe(
        tap(() => this.currentUserService.updateCurrentUser({ darkTheme })),
        catchError(() => {
          this.messageService.handleError<any>('update langage');
          return of({});
        })
      );
  }
}
